<template>
  <div class="p-6">
    <div class="mb-4">
      <h3 class="text-lg font-semibold mb-2 flex items-center gap-2">
        <i class="pi pi-chart-bar" style="color: var(--primary-gold);"></i>
        <span style="color: var(--text-primary);">Comparison Analysis</span>
      </h3>
      <p class="text-sm" style="color: var(--text-secondary);">
        Understanding how AshMatics compares to traditional approaches and other frameworks.
      </p>
    </div>

    <!-- This tab would typically show comparison tables or charts -->
    <!-- For now, we'll display a placeholder that indicates this is comparison content -->
    <div class="comparison-content">
      <div class="p-4 rounded-lg mb-4" style="background: var(--background-secondary);">
        <div class="flex items-start gap-3">
          <i class="pi pi-info-circle text-xl" style="color: var(--primary-gold);"></i>
          <div>
            <p class="text-sm" style="color: var(--text-secondary);">
              Comparison content is embedded in the Overview tab above.
              Refer to comparison tables and analysis sections for detailed framework comparisons.
            </p>
          </div>
        </div>
      </div>

      <!-- Quick comparison highlights -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="p-4 rounded-lg border" style="background: var(--background-primary); border-color: var(--border-light);">
          <h4 class="font-semibold mb-2" style="color: var(--text-primary);">
            <i class="pi pi-check-circle" style="color: var(--primary-gold);"></i>
            AshMatics Approach
          </h4>
          <ul class="space-y-2 text-sm" style="color: var(--text-secondary);">
            <li>• Governance-first methodology</li>
            <li>• Healthcare-specific design</li>
            <li>• Policy-process integration</li>
            <li>• Evidence by design</li>
          </ul>
        </div>

        <div class="p-4 rounded-lg border" style="background: var(--background-primary); border-color: var(--border-light);">
          <h4 class="font-semibold mb-2" style="color: var(--text-primary);">
            <i class="pi pi-times-circle" style="color: var(--text-muted);"></i>
            Traditional Approach
          </h4>
          <ul class="space-y-2 text-sm" style="color: var(--text-secondary);">
            <li>• Compliance-first methodology</li>
            <li>• Generic frameworks</li>
            <li>• Manual policy-process mapping</li>
            <li>• Separate documentation burden</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Section } from '@/types/ashmatics';

defineProps<{
  section: Section | null;
}>();
</script>
